export default "__VITE_ASSET__f361ce78__"